import Sagas from 'modules/Finance/PaymentProfiles/store/saga'
import Reducer from 'modules/Finance/PaymentProfiles/store/reducer'
import PaymentProfiles from 'modules/Finance/PaymentProfiles/PaymentProfiles'

export { Sagas as Sagas, Reducer }
export default PaymentProfiles
